import styled from "styled-components";

const ResumeStyles = styled.div`
  display: flex;
  padding: 80px 20px 75px;
  margin-top: 45px;
  border-top: 2px solid #000000;
  border-bottom: 2px solid #000000;
  background-color: #f2f1ed;

  > div {
    max-width: 1200px;
    margin: 0 auto;

    > div {
      max-width: 360px;
      font-size: 14px;
      line-height: 1.55;
      font-weight: 400;
      text-align: left;

      a {
        color: #000000;
      }
    }
  }

  @media (min-width: 641px) {
    > div {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 40px;
    }
  }

  @media (max-width: 640px) {
    > div {
      display: flex;
      flex-direction: column;
      row-gap: 40px;
    }
  }
`;

export { ResumeStyles };
